import React from 'react';

export const pageMeta = {
  "name": "Object Definitions",
  "link": "/javascript/objects/definitions"
};

export default function JavascriptObjectsDefinitions() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Object Definitions</h2>
      <p>Route: /javascript/objects/definitions</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
